import {SkeletonHelper} from 'three';

class SkeletonHelperView extends SkeletonHelper {
  constructor(root) {
    super(...arguments);
  }
}

export default SkeletonHelperView;
